(function FitBuilderView($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload(['/FitBuilders/view/', '/FitBuilderTemplates/view/'], function onload() {
			var $results_map = $(".fit-map"),
				data         = $results_map.data('results'),
				// eslint-disable-next-line no-unused-vars
				results_map,
				map_points_count = 0,
				styles =  [
				{
					featureType: "all",
					elementType: "geometry.fill",
					stylers    : [
						{
							weight: "2.00"
						}
					]
				},
				{
					featureType: "all",
					elementType: "geometry.stroke",
					stylers    : [
						{
							color: "#9c9c9c"
						}
					]
				},
				{
					featureType: "all",
					elementType: "labels.text",
					stylers    : [
						{
							visibility: "on"
						}
					]
				},
				{
					featureType: "landscape",
					elementType: "all",
					stylers    : [
						{
							color: "#f2f2f2"
						}
					]
				},
				{
					featureType: "landscape",
					elementType: "geometry.fill",
					stylers    : [
						{
							color: "#ffffff"
						}
					]
				},
				{
					featureType: "landscape.man_made",
					elementType: "geometry.fill",
					stylers    : [
						{
							color: "#ffffff"
						}
					]
				},
				{
					featureType: "poi",
					elementType: "all",
					stylers    : [
						{
							visibility: "off"
						}
					]
				},
				{
					featureType: "road",
					elementType: "all",
					stylers    : [
						{
							saturation: -100
						},
						{
							lightness: 45
						}
					]
				},
				{
					featureType: "road",
					elementType: "geometry.fill",
					stylers    : [
						{
							color: "#eeeeee"
						}
					]
				},
				{
					featureType: "road",
					elementType: "labels.text.fill",
					stylers    : [
						{
							color: "#7b7b7b"
						}
					]
				},
				{
					featureType: "road",
					elementType: "labels.text.stroke",
					stylers    : [
						{
							color: "#ffffff"
						}
					]
				},
				{
					featureType: "road.highway",
					elementType: "all",
					stylers    : [
						{
							visibility: "simplified"
						}
					]
				},
				{
					featureType: "road.arterial",
					elementType: "labels.icon",
					stylers    : [
						{
							visibility: "off"
						}
					]
				},
				{
					featureType: "transit",
					elementType: "all",
					stylers    : [
						{
							visibility: "off"
						}
					]
				},
				{
					featureType: "water",
					elementType: "all",
					stylers    : [
						{
							color: "#46bcec"
						},
						{
							visibility: "on"
						}
					]
				},
				{
					featureType: "water",
					elementType: "geometry.fill",
					stylers    : [
						{
							color: "#c8d7d4"
						}
					]
				},
				{
					featureType: "water",
					elementType: "labels.text.fill",
					stylers    : [
						{
							color: "#070707"
						}
					]
				},
				{
					featureType: "water",
					elementType: "labels.text.stroke",
					stylers    : [
						{
							color: "#ffffff"
						}
					]
				}
			];

			if ($(".fit-map").length > 0) {
				map_points_count = Object.keys(data.map).length;

				results_map = new Adzuki.Map($results_map, {
					zoom  : (map_points_count === 1 ? 10 : 3),
					styles: styles,
					init  : function map_init(map) {
						map.populate(data.map, true);
						map.drawGuidelines();
					}
				});
			}

			$('.fit-builder-carousel-image').click(function _showGallery() {
				var component_id  = $(this).data('component-id'),
					controller    = $(this).data('controller'),
					hotel_gallery = null;

				Adzuki.Ajax.post('/' + controller + '/galleryImages/' + component_id)
				.then(function sucess(response) {
					var images         = response;
					var gallery_images = [];

					if (images.length === 0) {
						return;
					}

					$.each(images, function onEachImage(i, image) {
						gallery_images.push({
							src    : image.src,
							thumb  : image.thumb,
							subHtml: image.subHtml,
						});
					});

					hotel_gallery = lightGallery($('.fit-builder-carousel-image')[0], {
						licenseKey       : 'github',
						download         : false,
						plugins          : [lgThumbnail],
						dynamic          : true,
						thumbnail        : true,
						toggleThumb      : true,
						allowMediaOverlap: true,
						dynamicEl        : gallery_images,
					});

					hotel_gallery.openGallery();
				});
			});

			$('.fit-builder-download').click(function _download(e) {
				var $modal = $('.modal'),
					id     = $(this).data('id'),
					type   = $(this).data('type');

				e.preventDefault();
				$modal.find('.modal-dialog').addClass('secure-storage');
				$modal.find('.modal-content').html('<div class="modal-body"><div class="modal-body__loader"></div><div class="text-center"><p>Preparing document...</p></div></div>');
				$modal.modal({
					backdrop: 'static',
					keyboard: false,
					show    : true
				});

				Adzuki.Ajax.get(Adzuki.base_uri + '/FitBuilders/export/' + id + '/' + type).then(function success(response) {
					const file_name = response.replace('fit_builder_exports/', '');
					window.open(Adzuki.base_uri + '/FitBuilders/downloadExport/' + file_name, '_blank');
					$modal.modal('hide');
				});

			});

			$('.fit-builder-component-interested').click(function _markInterested(e) {
				var component_id = $(this).data('component-id'),
					interested;

				e.preventDefault();

				if ($(this).hasClass('like')) {
					interested = 'like';

					// set it to filled for the like
					$('.fbi-like[data-component-id="' + component_id + '"]').html('<i class="fas fa-fw fa-thumbs-up"></i>');

					// set the dislike to empty
					$('.fbi-dislike[data-component-id="' + component_id + '"]').html('<i class="adzicon-thumbs_down far fa-fw fa-thumbs-down"></i>');
				} else {
					interested = 'dislike';

					// set it to filled for the dislike
					$('.fbi-dislike[data-component-id="' + component_id + '"]').html('<i class="fas fa-fw fa-thumbs-down"></i>');

					// set the like to empty
					$('.fbi-like[data-component-id="' + component_id + '"]').html('<i class="adzicon-thumbs_up far fa-fw fa-thumbs-up"></i>');
				}

				Adzuki.Ajax.get(Adzuki.base_uri + '/FitBuilders/componentInterested/' + component_id + '/' + interested).then(function success(response) {
					console.log('recorded');
				});
			});

			$('.offer-link').click(function offerLinkClicked(e) {
				var $self        = $(this),
					$offer_id    = $self.data("id"),
					$offer_title = $self.data("title");

				e.preventDefault();

				Adzuki.Ajax.get('/CruiseSearch/offerDetails/' + $offer_id)
					.then(function populateModal(content) {
						$(".modal-dialog").addClass('modal-lg');
						$(".modal-title").text($offer_title);
						$('.modal-body').html(content);
				});

				$('.modal').modal('show');
			});
		});

		_lookupWeather();
	});

	function _lookupWeather()
	{
		var weather_coords = $('#weather_coords').val(),
			html           = '';

		Adzuki.Ajax.post(
			'/FitBuilders/weatherMulti/',
			{
				weather_coords: weather_coords,
			}
		)
		.then(function success(content) {
			$('.fit-builder-weather').html('');

			$.each(content, function _iterateCoordinates(index, element) {
				if (element) {
					html = '<h4>Weather</h4>';
					html += '<div class="row">';
					html += '<div class="col-sm-1"><img class="img-responsive" src="http:' + element.icon + '"/></div>';
					html += '<div class="col-sm-11 pad10-vert-top fit-builder-large-text">Average ' + Math.round(element.min) + '&deg; to ' + Math.round(element.max) + '&deg;</div>';
					html += '</div>';

					$('.fit-builder-weather[data-key="' + index + '"]').html(html);
					html = '';
				}
			});
		});
	}
}(jQuery, window.Adzuki || {}));